import request from '@/utils/request'

export function getIndex() {
  return request({
    url: '/index/index/getIndex',
    headers: {
      // isToken: false
    },
    method: 'post',
  })
}

export function login(query) {
  return request({
    url: '/index/account/login',
    headers: {
      // isToken: false
    },
    method: 'post',
	params: query
  })
}

export function queryUser() {
  return request({
    url: '/index/account/queryUser',
    headers: {
      // isToken: false
    },
    method: 'post',
  })
}


export function sendSms(query) {
  return request({
    url: '/index/account/sendSms',
    headers: {
      // isToken: false
    },
    method: 'post',
	params: query
  })
}

export function smsLogin(query) {
  return request({
    url: '/index/account/smsLogin',
    headers: {
      // isToken: false
    },
    method: 'post',
	params: query
  })
}